module.exports = __webpack_public_path__ + "static/fire-shut-up-in-my-bones-22f9e91017c78478f7483f36a3d27393.jpg";